import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { JournalService } from '@journal/core/api/journal/journal.service';
import { environment } from '@journal/env/environment';
import { Blog } from '@sparro/app/core/models/blog.model';
import { User } from '@sparro/app/core/models/user.model';

@Component({
  selector: 'app-journal-header',
  templateUrl: './journal-header.component.html',
  styleUrls: ['./journal-header.component.scss'],
})

export class JournalHeaderComponent implements OnInit {
  @Input() blog: Blog;
  postUrl = null;

  @Input() imageCount: number;
  @Input() wordCount: number;
  @Input() embedCount: number;

  @Input() canPublish: boolean;
  @Input() next: boolean;
  @Input() user: User;
  @Input() lastSaved: string;
  currentUrl: string;

  isMetaRoute: boolean = false;
  small: boolean = false;

  constructor(
    private journalService: JournalService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.postUrl = `${environment.postUrl}`;
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit() {
    if (this.currentUrl.includes('/edit/') && this.currentUrl.includes('/meta')) {
      this.isMetaRoute = true;
    } else {
      this.isMetaRoute = false;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.next) {
      this.next = changes.next.currentValue
    }
    if (changes.canPublish) {
      this.canPublish = changes.canPublish.currentValue
    }
  }

  publishBlog() {
    if (!this.canPublish) {
      return;
    }
    else {
      this.journalService.publishBlog(this.blog.uuid).subscribe(
        (response: Blog) => {
          const success = response['success']
          if (success) {
            const slug = response['slug'];
            window.location.href = `${this.postUrl}${slug}`;
          }
        }, (err) => {
          console.log(err);
        });
    }
  }

  onClickNext() {
    if (!this.next) {
      return;
    }
    // console.log(this.blog.uuid);
    this.router.navigate(['./meta'], { relativeTo: this.route });
  }

  goBack() {
    if (this.currentUrl.includes('/edit/') && this.currentUrl.includes('/meta')) {
      this.router.navigate(['../'], { relativeTo: this.route });
    }
    if (this.currentUrl.includes('/edit/') && !this.currentUrl.includes('/meta')) {
      window.open(`${environment.profileUrl}edit/${this.user.username}/journals/`, '_self')
    }
  }
}
